/**
 * T-44b — shared labels/badge variants for weekly-report health on the leadership dashboard.
 * Every status is rendered with its TEXT label; colour is supplementary only (WCAG 1.4.1).
 */
import type { BadgeVariant } from "@/components/ui/badge";
import type { AttentionProject } from "@/types";

export type OverallStatus = AttentionProject["overall_status"];
export type RagValue = NonNullable<AttentionProject["schedule"]>;

export const OVERALL_META: Record<
  OverallStatus,
  { label: string; variant: BadgeVariant }
> = {
  on_track: { label: "On track", variant: "success" },
  at_risk: { label: "At risk", variant: "warning" },
  off_track: { label: "Off track", variant: "danger" },
};

export const RAG_META: Record<
  RagValue,
  { label: string; variant: BadgeVariant }
> = {
  green: { label: "Green", variant: "success" },
  yellow: { label: "Yellow", variant: "warning" },
  red: { label: "Red", variant: "danger" },
};

/** Bar fill per status — decorative; the adjacent text label + count carries the meaning. */
export const OVERALL_BAR_CLASS: Record<OverallStatus | "no_report", string> = {
  on_track: "bg-emerald-500",
  at_risk: "bg-amber-500",
  off_track: "bg-red-500",
  no_report: "bg-slate-300",
};

/** 'YYYY-MM-DD' → short local date ("Oct 19") without a UTC day shift. */
export function formatYmd(ymd: string): string {
  const [y, m, d] = ymd.split("-").map(Number);
  if (!y || !m || !d) return ymd;
  return new Date(y, m - 1, d).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
  });
}
